import React, { useState, useEffect } from 'react';
import { Share2 as ShareIcon } from 'react-feather';

const ShareNative = props => {
    const {
        classes,
        item: { name },
        url,
        ...rest
    } = props;

    const [isNativeShareAvailable, setIsNativeShareAvailable] = useState(false);

    useEffect(() => {
        setIsNativeShareAvailable('share' in navigator);
    }, []);

    const share = () => {
        navigator.share({
            title: name,
            text: _('Check out the {0} that I have configured', name),
            url
        });
    };

    if (isNativeShareAvailable !== true) {
        return null;
    }

    if (!isNativeShareAvailable) {
        return null;
    }

    return (
        <button onClick={share} className={classes.button}>
            <ShareIcon className={classes.icon} />
            {_('Share')}
        </button>
    );
};

export default ShareNative;
